import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongJin OH
 * @contact hjoh@detech.co.kr
 * @date 2024-08-20
 * @brief SEI 에너지솔루션 관리 -tree 개발
 *
 ********************************************************************/
export default function EnergySolutionManagementTree(props) {
    const { treeItem, treeSel, setTreeSel, menuSel, setMenuSel } = props;
    // mian tree 클릭
    const onClickTree = (menu) => {
        setTreeSel(menu);
        if (menu.id !== treeSel.id) {
            onClickMenu(0);
        }
    };
    // sub tree 클릭
    const onClickMenu = (id) => {
        setMenuSel(id);
    };
    return (_jsx(_Fragment, { children: _jsx("div", Object.assign({ className: "lnb" }, { children: _jsx("ul", Object.assign({ className: "lnb-depth1" }, { children: treeItem.map((menu, idx) => (_jsxs("li", Object.assign({ className: `${treeSel.id == menu.id ? "active" : ""}`, onClick: (e) => onClickTree(menu) }, { children: [_jsx("p", { children: _jsx("a", Object.assign({ href: "#", onClick: (e) => e.preventDefault() }, { children: _jsx("span", Object.assign({ className: `${idx > 0 ? "wmax-100p" : ""}` }, { children: menu.name })) })) }), _jsx("ul", Object.assign({ className: "lnb-depth2 basic" }, { children: menu.smenu.map((smenu, index) => (_jsx("li", Object.assign({ className: `${treeSel.id + menuSel == menu.id + index ? "active" : ""}`, onClick: (e) => onClickMenu(index) }, { children: _jsx("a", Object.assign({ href: "#", onClick: (e) => e.preventDefault() }, { children: _jsx("p", { children: smenu.menuName }) })) }), "energySubTree_" + index.toString()))) }))] }), "energyTree_" + idx.toString()))) })) })) }));
}
